var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckpoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.487 27.4726C20.9357 27.4726 26.9741 21.4342 26.9741 13.9856C26.9741 6.53688 20.9357 0.498535 13.487 0.498535C6.03835 0.498535 0 6.53688 0 13.9856C0 21.4342 6.03835 27.4726 13.487 27.4726ZM20.2487 10.1295L18.7138 8.85032L11.9213 17.0012L8.19922 13.2791L6.78637 14.692L12.0556 19.9612L20.2487 10.1295Z",
    fill: "#DAC7FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckpoint);
export default __webpack_public_path__ + "static/media/checkpoint.f1192641eda95b1eadd3f5ed6af32b84.svg";
export { ForwardRef as ReactComponent };